module.exports = __webpack_public_path__ + "media/images/icon__warning-e00c1c4fc6b5ed03d16bcf86505e070f.png";